import { SearchIcon } from "@heroicons/react/outline";
import clsx from "clsx";
import React from "react";

interface SearchInputProps extends React.HTMLProps<HTMLInputElement> {
  onSearchTermChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classes?: string;
}

export function SearchInput({ onSearchTermChange, classes, ...rest }: SearchInputProps) {

  return <div className={clsx(`relative flex items-stretch focus-within:z-10`, classes)}>
    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <SearchIcon
        className="h-5 w-5 text-gray-400"
        aria-hidden="true"
      />
    </div>
    <input
      {...rest}
      type="text"
      onChange={onSearchTermChange}
      className="focus:ring-etpink-500 focus:border-etpink-500 block w-full rounded-md pl-10 sm:text-sm border-gray-300"
    />
  </div>
}